module.exports = __webpack_public_path__ + "img/img.d4fd7028.svg";